import renderMathInElement from "katex/contrib/auto-render";
import { escapeHtml } from "./escapeHtml.js";

/** Escaped LaTeX source wrapped for the preview pane (KaTeX fills in math delimiters). */
export function buildTexPreviewHtml(source: string): string {
  const escaped = escapeHtml(source);
  return `<pre class="npp-tex-preview-pre">${escaped}</pre>`;
}

/** Tags KaTeX skips by default; we omit `pre` because {@link buildTexPreviewHtml} wraps source in `<pre>`. */
const KATEX_AUTO_RENDER_IGNORED_TAGS = [
  "script",
  "noscript",
  "style",
  "textarea",
  "code",
  "option",
] as const;

/** Run KaTeX auto-render on a preview root (call after setting {@link buildTexPreviewHtml} HTML). */
export function renderTexMathInPreviewRoot(el: HTMLElement): void {
  renderMathInElement(el, {
    delimiters: [
      { left: "$$", right: "$$", display: true },
      { left: "\\[", right: "\\]", display: true },
      { left: "\\(", right: "\\)", display: false },
    ],
    throwOnError: false,
    strict: "ignore",
    ignoredTags: [...KATEX_AUTO_RENDER_IGNORED_TAGS],
  });
}
